import { orderXClient } from '@/service/client'
import {
  ChartData,
  ChartDataRequest,
  DataPayload,
  ServerMessage,
  TimeResponse,
  VisibleRangeProfile,
  VisibleRangeProfileRequest,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchChartData(payload: ChartDataRequest, signal?: AbortSignal) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      {
        // from/to are int64 seconds: a fractional value (TV pages tick resolutions in
        // sub-second steps) fails the protobuf encode before the request is even sent.
        chartData: {
          ...payload,
          ...(payload.from !== undefined && { from: String(Math.floor(Number(payload.from))) }),
          ...(payload.to !== undefined && { to: String(Math.ceil(Number(payload.to))) }),
        },
      },
      {
        headers: {
          'X-Decode-Key': 'datapayload',
        },
        signal,
      }
    )
    const chartDataResponse = data.chartData
    if (!chartDataResponse) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch chart data',
      })
    }
    return chartDataResponse as ChartData
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function fetchServerTime() {
  try {
    const { data } = await orderXClient.post<ServerMessage>('/api', {
      time: {},
    })
    const timeResponse = data.timeResponse
    if (!timeResponse) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch server time',
      })
    }
    return timeResponse as TimeResponse
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}

export async function fetchVisibleRangeProfile(
  payload: VisibleRangeProfileRequest,
  signal?: AbortSignal
) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      {
        visibleRangeProfile: payload,
      },
      {
        headers: {
          'X-Decode-Key': 'datapayload',
        },
        signal,
      }
    )
    const profile = data.visibleRangeProfile
    if (!profile) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch visible range profile',
      })
    }
    return profile as VisibleRangeProfile
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
